import { Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { IconButton } from '@design-system/components/button/iconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { ButtonLink } from '@design-system/components/button/button';
import { F0 } from '@client/new/helpers/types';

// TODO: [j] move to the @desing-system
export const ProgramDuplicatedToast = (p: {
  name: string;
  programURL: string;
  onClose: F0;
}) => {
  const { name, programURL, onClose } = p;
  return (
    <Row>
      <Typography variant="body" fontWeight="medium">
        {name} has been successfully duplicated and is ready to go! You can find
        this program over in your drafts tab.
      </Typography>

      <ButtonLink variant="text" color="primary" to={programURL}>
        Open
      </ButtonLink>

      <IconButton variant="text" color="primary" onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} />
      </IconButton>
    </Row>
  );
};
